import React from 'react';
import Quiz from '../Quiz/Quiz';
import WordInterventionModal from '../WordInterventionModal';

export default class QuizIntervention extends React.Component {
  constructor (props){
    super(props);
  }

  render() {
  	let quiz = (
      <div className="quizInterventionContainer">
        <Quiz
          speech={this.props.speech}
          questions={this.props.questions}
          readQuestionDefault={true}
          feedbackModeDefault={true}
          onSubmit={this.props.onSubmit}
        />
      </div>
  	);
    return (
      <WordInterventionModal
        useWordIcon={true}
        rightContent={quiz}
      />
    );
  }
}